import { types, actions } from './requests'
export const CREATEPRODUCTION_TYPES = {
    ...types('CREATEPRODUCTION'),
}
export const CREATEPRODUCTION_ACTIONS = {
    ...actions('CREATEPRODUCTION'),
}